export enum UserHistoryOperation {
  ASSIGN_TO = 'ASSIGN_TO',
  UN_ASSIGN_FROM = 'UN_ASSIGN_FROM',
  UPDATE_CLIENT_USER = 'UPDATE_CLIENT_USER',
  COMMENT_MENTIONED = 'COMMENT_MENTIONED',
  CLIENT_TASK_CREATE = 'CLIENT_TASK_CREATE',
  ASSIGN_TO_TASK = 'ASSIGN_TO_TASK',
  UN_ASSIGN_FROM_TASK = 'UN_ASSIGN_FROM_TASK',
  DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS',
}

export type UserNotificationItem = {
  _id: string;
  message: string;
  date?: string;
  isRead: boolean;
  clickAction: () => void;
  createdBy?: {
    name: string;
    picture: string;
  };
  updatedBySystem?: boolean;
};

